<template>
  <div class="procell">
    <van-list
      v-model="loadingData"
      :finished="finished"
      :finished-text="coursedata.length==0?'该类商品为空':'已经到底了'"
      @load="onLoad"
    >
      <div
        class="contentCell clearfix"
        v-for="(item, index) in coursedata"
         :key="index"
        @click="clickCell(index)"
      >
        <div
          style="display: inline-block; position: relative"
          class="left_img_box"
        >
          <van-image :src="item.img | getavatar" />
          <div class="company_name">{{item.company}}</div>
        </div>

        <div class="rightView">
          <div class="title ov2 ml12 " style="text-align:left;margin-top:0">
            {{ item.productName }}
          </div>
          <div style="text-align: left;display:flex;flex-wrap:wrap" class="ml12">
            <span v-for="(itm, inx) in item.label.split(',')" :key="inx+'1'" class="job">{{
              itm
            }}</span>
          </div>
          <div class="time ml12">
              <div v-if="item.expireTime">停售时间：{{item.expireTime|getdate}}</div>
              <!-- <div>保障期间：{{item.period}}</div> -->
          </div>
          <div class="price ml12">
              <span >{{item.minAmount}}</span>
            <span class="p1">元起</span>
          </div>
        </div>
      </div>
      <van-empty v-if="coursedata.length==0&&!loadingData"  :image="require('../../assets/img/none.png')"  />
    </van-list>
  </div>
</template>

<script>
import { List } from "vant";
export default {
  name: "coursecell",
  data() {
    return {
      loadingData: false,
    };
  },

  props: {
    coursedata: {
      default: {},
    },
    loading: false,
    finished: false,
  },
  watch: {
    // <van-list v-model="loading"  属于双向绑定。子组件不能改变props的值，会报错。在data上弄个副本值
    loading(newVal) {
      console.log("000000", newVal);
      this.loadingData = newVal;
    },
  },

  methods: {
    clickCell(index) {
      console.log("jiojojoj", index);
      this.$emit("watchCourse", index);
    },
    //上拉加载数据
    onLoad() {
      this.$emit("footerRefresh");
    },
  },
  mounted() {},
  filters: {
    getavatar(val) {
      if (val) {
        if (val.indexOf("http") == -1) {
          if (val.indexOf("/avatar/") == -1) {
            return process.env.VUE_APP_URL + "/avatar/" + val;
          } else {
            console.log(val.split("zlxadmin")[1]);
            return process.env.VUE_APP_URL + val.split("zlxadmin")[1];
          }
        } else {
          return val;
        }
      } else {
        return require("../../assets/img/timg.jpeg");
      }
    },
    getdate(val){
      if(val){
        let time=new Date(val)
        let year=time.getFullYear()
        let month=time.getMonth()*1+1
        let date=time.getDate()
        if(month<10)month='0'+month
        if(date<10)date='0'+date
        return year+'-'+month+'-'+date
      }
    }
  },
};
</script>

<style  lang="less">
  .van-empty .van-empty__image {
    width: 192px !important;
    height: 128px !important;
  }
.procell {
  
  .clearfix:after {
    content: " ";
    display: block;
    clear: both;
    line-height: 0;
    height: 0;
  }
  .contentCell {
    position: relative;
    //   width: 100%;
    // border-top: 1px solid @gray-light;
    margin: 0 12px;
    padding: 12px 0px;
    box-sizing: border-box;
    display: flex;
    img {
      width: 100%;
      height: 100%;
    }
    .left_img_box {
      width: 102px;
      height: 102px;
      border-radius: 6px;
      font-size: 12px;
      overflow: hidden;
      padding-bottom: 22px;
      img{
        width: 102px;
      height: 80px;
      }
    }
    //   span {
    //     color: white;
    //   }
    .rightView {
      padding: 0 11px 0 0;
      margin: 0;
      float: right;
      height: 100%;
      width: 226px;
      .title {
        font-size: 16px;
        color: rgba(16, 16, 16, 100);
        font-family: PingFangSC-bold;
        width: 100%;
        line-height: 25px;
      }
      .categoryView {
        color: rgba(151, 144, 144, 100);
        font-size: 14px;
      }

      .learnedView {
        color: @orange;
        font-size: 14px;
        color: @detail-color;
        line-height: 20px;
        span {
          color: @orange;
        }
      }
      .priceView {
        position: absolute;
        right: 0;
        bottom: 10px;
        color: @red-dark;
        font-size: 20px;
      }
    }
    .typeview {
      width: 46px;
      height: 17px;
      background-color: rgba(15, 15, 18, 65);
      color: #fff;
      position: absolute;
      font-size: 12px !important;
      text-align: center;
      font-family: -apple-system;
      line-height: 17px;
      bottom: 4px;
      left: 25px;
      border-radius: 10px;
    }
    .h17 {
      height: 17px;
      margin: 8px 0 6px 0;
    }
    .ml12{
        margin-left: 12px;
        margin-top: 9px;
    }
    .job {
      line-height: 20px;
      background-color: rgba(225, 236, 252, 100);
      text-align: center;
      border: 1px solid rgba(255, 255, 255, 100);
      color: rgba(50, 147, 220, 100);
      font-size: 10px;
      font-family: PingFangSC-regular;
      padding: 3px 5px;
      border-radius: 2px;
      margin-right: 8px;
    }
    .time{
        color: #ff5f3f;
        font-size: 12px;
        font-family: PingFangSC-regular;
        line-height: 18px;
        text-align: left;
    }
    .price{
        color: rgba(253, 92, 14, 100);
        font-size: 20px;
        text-align: left;
        font-family: PingFangSC-bold;
        font-weight: bold;
        .p1{
            font-size: 11px;
            margin-left:8px;
        }
    }
  }
  
    .company_name{
        width: 100%;
        height: 22px;
        line-height: 22px;
        border-radius: 0px 0px 6px 6px;
        background-color: rgba(246, 245, 245, 95);
        text-align: center;
        border: 1px solid rgba(255, 255, 255, 100);
        position: absolute;
        bottom: 0;
        left: 0;
        font-size: 13px;
        font-family: PingFangSC-regular;
        color: rgba(138, 136, 136, 100);
    }
}
</style>